var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 49 48","width":"49","height":"48"}},[_c('path',{attrs:{"fill":"#D1D7E8","fill-rule":"evenodd","d":"M24.666 46s18-12 18-26a18 18 0 1 0-36 0c0 14 18 26 18 26zm6-26a6 6 0 1 1-12 0 6 6 0 0 1 12 0z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }